const promises = {};
export default class AsyncScriptService {
  static load(paths, requirables) {
    const pathsArr = paths && [].concat(paths);
    const requirablesArr = requirables && [].concat(requirables);
    const requireable = window.require.list();
    const queue = [];

    pathsArr.forEach(path => {
      // path example: { http: 'javascripts/blocks/modal.js', require: 'views/block/modal-view'}
      const scriptTag = document.querySelector(`script[src="${path.http}"]`);
      if (requireable.includes(path.require)) {
        // Note: this fake promise must be here to preserve the order of the arguments
        return queue.push(Promise.resolve(path));
      }
      if (scriptTag === null) {
        const script = document.createElement('script');
        script.src = path.http;
        script.async = path.async || false;
        promises[path.http] = new Promise(resolve => {
          script.onload = e => {
            path.event = e;
            resolve(path);
          };
        });
        queue.push(promises[path.http]);
        document.body.appendChild(script);
      } else {
        //if script tag is present, we should have a promise available
        queue.push(promises[path.http]);
      }
    });

    // Note Promise.all preserves order, this is important for the arguments to line up
    return Promise.all(queue).then(loaded => {
      const hasRequirables = requirablesArr && requirablesArr.length;
      const pathArr = hasRequirables ? requirablesArr : loaded;

      return Promise.resolve(
        pathArr.map(path => {
          const required = window.require(hasRequirables ? path : path.require);
          return required.default ? required.default : required;
        })
      );
    });
  }
}
